(function (window) {
  'use strict';

  const activeVariantClass = 'js-card-variant--active';
  const variantSliderPagesAttribute = 'data-pages';
  const variantSliderPageAttribute = 'data-page';
  const variantSliderButtonDirectionAttribute = 'data-direction';
  const variantSliderHiddenButtonClass = 'js-card-variants-slider-button--hidden';

  function switchVariant(e) {
    const variant = e.target.closest('.js-card-variant');

    if (!variant.classList.contains(activeVariantClass)) {
      const card = variant.closest('.js-card');
      const cardVariants = card.querySelectorAll('.js-card-variant');

      for (let i = 0; i < cardVariants.length; i++) {
        cardVariants[i].classList.remove(activeVariantClass);
        cardVariants[i].firstElementChild.setAttribute('aria-pressed', false);
      }

      variant.classList.add(activeVariantClass);
      variant.firstElementChild.setAttribute('aria-pressed', true);

      switchImageVariant(card, variant.getAttribute('data-sku'));

      switchStatusVariant(card, variant.getAttribute('data-sku'));

      switchNameVariant(card, variant.getAttribute('data-sku'));

      switchPriceVariant(card, variant.getAttribute('data-sku'));
      
      switchOriginalPriceVariant(card, variant.getAttribute('data-sku'));

      switchUrlVariant(card, variant.getAttribute('data-sku'));

      switchStockVariant(card, variant.getAttribute('data-sku'));
    }

    e.preventDefault();
  }

  function variantMouseover(e) {
    const hoveredVariant = e.target.closest('.js-card-variant');

    if (!hoveredVariant.classList.contains(activeVariantClass)) {
      const card = hoveredVariant.closest('.js-card');
      const color = hoveredVariant.getElementsByTagName('button')[0].innerHTML;

      switchImageVariant(card, hoveredVariant.getAttribute('data-sku'));
      switchAltTagVariant(card, color);
      switchNameVariant(card, hoveredVariant.getAttribute('data-sku'));
      switchCardLinkAriaLabel(card, color);
    }
  }

  function variantMouseout(e) {
    const card = e.target.closest('.js-card');
    const activeVariant = card.querySelector('.' + activeVariantClass);
    const color = activeVariant.getElementsByTagName('button')[0].innerHTML;

    switchImageVariant(card, activeVariant.getAttribute('data-sku'));
    switchAltTagVariant(card, color);
    switchNameVariant(card, activeVariant.getAttribute('data-sku'));
    switchCardLinkAriaLabel(card, color);
  }

  function switchImageVariant(card, newVariantId) {
    const cardImage = card.querySelector('.js-card-image');
    const currentAngleId = cardImage.getAttribute('data-angle');
    const newImageAttribute = 'data-' + newVariantId + '-' + currentAngleId;

    cardImage.setAttribute('src', cardImage.getAttribute(newImageAttribute));
    cardImage.setAttribute('data-variant', newVariantId);
  }

  function switchAltTagVariant(card, color) {
    const cardImage = card.querySelector('.js-card-image');
    const newAngle = cardImage.getAttribute('data-angle');
    const style = cardImage.getAttribute('data-style');
    const newAltAttribute = color + ' ' + style + ' ' + newAngle + ' View';

    cardImage.setAttribute('alt', newAltAttribute);
    cardImage.setAttribute('data-color', color);
  }


  function switchStatusVariant(card, newVariantId) {
    const cardStatus = card.querySelector('.js-card-status');
    const newStatusAttribute = 'data-' + newVariantId + '-status';

    if (cardStatus) {
      cardStatus.textContent = cardStatus.getAttribute(newStatusAttribute);
    }
  }

  function switchCardLinkAriaLabel(card, color) {
    const cardUrl = card.querySelector('.js-card-url');
    const newAriaLabelAttribute = 'View ' + color + ' product page';
    cardUrl.setAttribute('aria-label', newAriaLabelAttribute);
  }

  function switchNameVariant(card, newVariantId) {
    const cardName = card.querySelector('.js-card-variant-name');
    const newNameAttribute = 'data-' + newVariantId + '-variant-name';

    if (cardName) {
      cardName.textContent = cardName.getAttribute(newNameAttribute);
    }
  }

  function switchPriceVariant(card, newVariantId) {
    const cardPrice = card.querySelector('.js-card-price');
    const newPriceAttribute = 'data-' + newVariantId + '-price';

    if (cardPrice) {
      cardPrice.textContent = cardPrice.getAttribute(newPriceAttribute);
    }
  }

  function switchOriginalPriceVariant(card, newVariantId) {
    const cardOriginalPrice = card.querySelector('.js-card-original-price');
    const newPriceAttribute = 'data-' + newVariantId + '-original-price';

    if (cardOriginalPrice) {
      cardOriginalPrice.textContent = cardOriginalPrice.getAttribute(newPriceAttribute);
    }
  }

  function switchUrlVariant(card, newVariantId) {
    const cardUrl = card.querySelector('.js-card-url');
    const newUrlAttribute = 'data-' + newVariantId + '-url';

    cardUrl.setAttribute('href', cardUrl.getAttribute(newUrlAttribute));
  }

  function switchStockVariant(card, newVariantId) {
    const disabledButtonClass = 'js-button-disabled';
    const callToActionButton = card.querySelector('.card__call-to-action-button');
    const cardUrl = card.querySelector('.js-card-url');
    const newStockAttribute = 'data-' + newVariantId + '-stock';
    const newStockValue = cardUrl.getAttribute(newStockAttribute);

    if (callToActionButton) {
      if (newStockValue === "true") {
        callToActionButton.classList.remove(disabledButtonClass);
      }
      else {
        callToActionButton.classList.add(disabledButtonClass);
      }
    }
  }

  function selectVariant(e) {
    const card = e.currentTarget;

    card.classList.add('card--reserved-style');

    card.removeEventListener('selectVariant', selectVariant);
    card.addEventListener('confirmVariant', confirmVariant, {once: true});
    card.addEventListener('deselectVariant', deselectVariant, {once: true});
    card.addEventListener('resetVariant', resetVariant, {once: true});
  }

  function deselectVariant(e) {
    const card = e.currentTarget;

    card.classList.remove('card--reserved-style');

    card.removeEventListener('confirmVariant', confirmVariant);
    card.removeEventListener('resetVariant', resetVariant);
    card.removeEventListener('deselectVariant', deselectVariant);
    card.addEventListener('selectVariant', selectVariant, {once: true});
  }

  function confirmVariant(e) {
    const card = e.currentTarget;
    const container = card.parentElement;

    container.classList.remove('modal-form__item-group--product');
    container.classList.add('modal-form__item-group--reserved-product');

    card.classList.remove('card--reserved-style');
    card.classList.remove('card--reserve-in-store');
    card.classList.add('card--confirmed-style');

    card.removeEventListener('confirmVariant', confirmVariant);
    card.removeEventListener('deselectVariant', deselectVariant);
  }

  function unconfirmVariant(e) {
    const card = e.currentTarget;
    const container = card.parentElement;

    container.classList.add('modal-form__item-group--product');
    container.classList.remove('modal-form__item-group--reserved-product');

    card.classList.add('card--reserved-style');
    card.classList.add('card--reserve-in-store');
    card.classList.remove('card--confirmed-style');

    card.addEventListener('confirmVariant', confirmVariant, {once: true});
    card.addEventListener('deselectVariant', deselectVariant, {once: true});
  }

  function resetVariant(e) {
    unconfirmVariant(e);
    deselectVariant(e);
  }

  function applyFocusWithin(e) {
    e.currentTarget.setAttribute('focus-within', true);
  }

  function removeFocusWithin(e) {
    e.currentTarget.setAttribute('focus-within', false);
  }

  function duplicateAttribute(parent, attr) {
    const child = parent.children[0];
    const attrValue = parent.getAttribute(attr);
    attrValue ? child.setAttribute(attr, attrValue) : child.removeAttribute(attr);
  }

  function init() {
    const cards = Array.prototype.filter.call(document.querySelectorAll('.js-card'), el => !el.classList.contains('card--confirmed-style'));
    const cardVariants = document.querySelectorAll('.card__variant');

    for (let i = 0; i < cards.length; i++) {
      if (!cards[i].classList.contains('js-component-init')) {
        const card = cards[i];
        const variants = card.querySelectorAll('.js-card-variant');

        for (let j = 0; j < variants.length; j++) {
          variants[j].addEventListener('click', switchVariant);
          variants[j].addEventListener('mouseover', variantMouseover);
          variants[j].addEventListener('mouseout', variantMouseout);
        }

        if (variants.length > 5 && !card.classList.contains('card--reserve-in-store')) {
          const slider = tns({
            container: card.querySelector('.js-card-variants'),
            controlsContainer: card.querySelector('.js-card-variants-controls'),
            items: 5,
            slideBy: 5,
            nav: false,
            loop: false,
            onInit: () => {
              // Forced tabindex="0" to make "prev" and "next" slider buttons keyboard accessible.
              const prevNextButtons = card.querySelectorAll('.card__variants-control');
              for (let i = 0; i < prevNextButtons.length; i++) {
                prevNextButtons[i].setAttribute('tabindex', 0);
              }
              // Initialization that add attributes "tabindex" and "aria-hidden" to the child button of each li.card__variant.
              cardVariants.forEach(function(variant) {
                duplicateAttribute(variant, 'tabindex')
                duplicateAttribute(variant, 'aria-hidden')
              })
            }
          });
        }

        if (card.classList.contains('card--reserve-in-store')) {
          card.addEventListener('selectVariant', selectVariant, {once: true});
        }
        // Prevent a card from being initialized more than once.
        card.classList.add('js-component-init');
      }
    }

    cardVariantObserver(cardVariants);
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  // Polyfill :focus-within if not supported.
  try {
    document.querySelector(':focus-within');
  } catch (err) {
    const focusableCards = document.querySelectorAll('.card__inner');
    if (focusableCards.length) {
      Array.prototype.forEach.call(focusableCards, function (card) {
        card.setAttribute('focus-within', false);
        card.addEventListener('focusin', applyFocusWithin);
        card.addEventListener('focusout', removeFocusWithin);
      });
    }
  }

  function cardVariantObserver(cardVariants) {
    // Mutation Observer to inherit "tabindex" and "aria-hidden" attributes to the child button of each li.card__variant.
    // By using an observer we prevent the modification of the tiny-slider.js library.
    // More documentation available on:
    // https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
    const observer = new MutationObserver( function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'tabindex') {
          duplicateAttribute(mutation.target, 'tabindex');
        }
        if (mutation.attributeName === 'aria-hidden') {
          duplicateAttribute(mutation.target, 'aria-hidden'); 
        }
      })
    });

    cardVariants.forEach(function(variant) {
      observer.observe(variant, { attributes: true});
    });
  }

  init();

})(this);
